export enum DictionaryType {
    NONE = "NONE",
    SINGLE = "SINGLE",
    SHARED = "SHARED",
    VERTEX = "VERTEX",
    MORTON = "MORTON",
    FSST = "FSST",
}
